import configureStore from './configureStore'
const store = configureStore()

/**
 * The singleton store that is used in the application.
 */
export default store



// WEBPACK FOOTER //
// ./src/store/index.js